<template>
	<div style="padding: 10px 10px 10px 0;">
		<el-dialog :visible.sync="show" width="100%" id="printTest" :before-close="handleClose">
			<div
				style="border-top: 1px solid #000000;border-bottom: 1px solid #000000;text-align: center;font-size: 24px;padding: 5px 0;">
				缴款通知书</div>
			<div>
				商品名称: {{ obj.shopName }}
			</div>
			<div>经营品牌: {{ obj.shopName }}</div>
			<div style="display: flex;justify-content: space-between;border-bottom: 1px solid #000000;">
				<div>商铺编号: {{ obj.shopNum }}</div>
				<div>合同号: {{ obj.number }}</div>
			</div>
			<div>尊敬的供应商:</div>
			<div style="margin: 5px 0;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;根据贵我双方租赁合同中的有关条款约定，请贵司按期将下列款项汇至本公司账户。
			</div>
			<div>户名: 江苏国际人才咨询服务有限公司</div>
			<div style="margin: 5px 0;">开 户 银 行: 中国银行江苏省分行营业部</div>
			<div>账号: 5092 6897 8348</div>
			<div style="margin:20px 0 0 30px;">谢谢合作!</div>
			<el-table :data="bdShopPayList" style="width: 100%" border>
				<el-table-column width="130" prop="type" label="款项类别"></el-table-column>
				<el-table-column width="130" prop="term" label="所属期限">

				</el-table-column>
				<el-table-column width="130" prop="appdate" label="最后缴款日">
					<template slot-scope="{row}">
						{{ row.appdate.split("T")[0] }}
					</template>
				</el-table-column>
				<el-table-column width="130" prop="money" label="应交金额(元)"></el-table-column>
				<el-table-column width="130" prop="remark" label="备注"></el-table-column>
			</el-table>
			<!-- 	<div style="margin: 0 0 5px 10px;">备注:提成租金:第1年5%扣点。</div> -->
			<div style="margin: 0 0 0 15px;">电费:1元/度: 水费:按公共事业公布标准+10%的管理费</div>
			<div style="margin: 0 0 0 15px;">合计:{{ sum }}元</div>
			<div style="text-align: right;margin-top: 50px;">江苏国际人才咨询服务有限公司</div>
			<div style="text-align: right;">{{ new Date().getFullYear() }}年{{ new Date().getMonth() + 1 }}月{{ new
		Date().getDate()
}}日</div>
			<span v-if="isDyxs" slot="footer" class="dialog-footer">
				<el-button @click="show = false">关 闭</el-button>
				<el-button plain v-print="'#printTest'" @click="isDyxs = false" type="primary">打 印</el-button>
			</span>
		</el-dialog>

		<el-dialog title="修改" :visible.sync="isChange" width="30%">
			<el-form :model="form">
				<el-form-item label="缴费状态">
					<el-select v-model="status" placeholder="状态" style="width: 100px;">
						<el-option label="已缴费" value="已缴费"></el-option>
						<el-option label="未缴费" value="未缴费"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="isChange = false">关 闭</el-button>
				<el-button @click="isOk" type="primary">确 定</el-button>
			</span>
		</el-dialog>
		<el-form :inline="true" :model="form" class="demo-form-inline">
			<div class="flex sb">
				<div>
					<el-form-item label="商铺号">
						<el-input v-model="form.shopNum" placeholder="商铺号" style="width: 100px;"></el-input>
					</el-form-item>
					<el-form-item label="商铺名称">
						<el-input v-model="form.shopName" placeholder="商铺名称" style="width: 100px;"></el-input>
					</el-form-item>
					<el-form-item label="联系人">
						<el-input v-model="form.name" placeholder="联系人" style="width: 100px;"></el-input>
					</el-form-item>
					<el-form-item label="联系方式">
						<el-input v-model="form.phone" placeholder="手机号" style="width: 120px;"></el-input>
					</el-form-item>
					<el-form-item label="缴费状态">
						<el-select v-model="form.status" placeholder="状态" style="width: 100px;">
							<el-option label="已缴费" value="已缴费"></el-option>
							<el-option label="未缴费" value="未缴费"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="提醒状态">
						<el-select v-model="form.remind" placeholder="提醒状态" style="width: 100px;">
							<el-option label="已提醒" value="已提醒"></el-option>
							<el-option label="未提醒" value="未提醒"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="getAll">查询</el-button>
					</el-form-item>
				</div>
				<div>
					<el-button type="primary" @click="dc">导出</el-button>
				</div>
			</div>
		</el-form>
		<el-table :data="data" style="width: 100%" border>
			<el-table-column prop="shopNum" label="商铺号"></el-table-column>
			<el-table-column prop="shopName" label="商铺名称"></el-table-column>

			<el-table-column prop="name" label="联系人"></el-table-column>
			<el-table-column prop="phone" label="联系方式">
				<template slot-scope="{row}">{{ row.phone ? row.phone : "无" }}</template>
			</el-table-column>
			<el-table-column prop="type" label="缴费类型"></el-table-column>
			<el-table-column prop="appdate" label="最后缴款日">
				<template slot-scope="{row}">
					{{ row.appdate.split("T")[0] }}
				</template>
			</el-table-column>
			<el-table-column prop="money" label="应缴金额"></el-table-column>
			<el-table-column prop="status" label="缴费状态">
				<template slot-scope="{row}">
					<span :style="row.status == '已缴费' ? 'color:#30C25B' : 'color:red'">{{ row.status }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="remind" label="提醒状态"></el-table-column>
			<el-table-column prop="date" label="操作">
				<template slot-scope="{row}">
					<el-button type="text" @click="lookRow(row)">查看</el-button>
					<!-- <el-button type="text" @click="changeRow(row)">修改</el-button> -->
				</template>
			</el-table-column>
		</el-table>
		<el-pagination :page-sizes="[10, 20, 30, 50]" :page-size="form.pageSize" @size-change="handleSizeChange"
			@current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="count">
		</el-pagination>
	</div>
</template>

<script>
import publicExport from '../../assets/js/publicExport.js';
import downloadFile from '../../assets/js/downloadFile.js';
export default {
	data() {
		return {
			sum: 0,
			count: 0,
			isDyxs: true,
			users: [], //申请人
			show: false,
			status: '',
			id: '',
			bdShopPayList: [],
			form: {
				"applyId": "", //申请人id
				"phone": "", //联系电话
				"result": "", //状态
				"shopName": "", //商铺名称
				"shopNum": "", //商铺号
				"type": "", //类型（正常，违规）
				"currentPage": 0,
				"pageSize": 0,
			},
			addForm: {},
			data: [],
			obj: {
				fileRes: "",
				applyTime: ""
			}, //详情数据
			isChange: false
		}
	},
	methods: {
	
		handleClose() {
			this.show = false
			this.isDyxs = true
		},
		downFil(item) {
			downloadFile(item)
		},
		changeRow(obj) {
			this.id = obj.id
			this.status = obj.status
			this.isChange = true
		},
		isOk() {
			this.$http.post("/api/shopPay/updateShopPay", {
				id: this.id,
				status: this.status
			}).then(res => {
				if (res.data.code == 0) {
					this.$message.success(res.data.message)
					this.isChange = false
					this.getAll()
				}
				console.log(res)

			})
		},
		lookRow(obj) {
			this.$http.get(`/api/shopPay/selectOne?id=${obj.id}`).then(res => {
				if (res.data.code == 200) {
					this.obj = res.data.data
					res.data.data.bdShopPayList.forEach(val => {
						console.log(val.money)
						this.sum = Math.floor(val.money * 100) / 100 + this.sum
					})
					this.bdShopPayList = res.data.data.bdShopPayList
					this.show = true;
				} else {
					this.$message.error(res.data.msg)
				}

			})
		},
		handleCurrentChange(val) {
			this.form.currentPage = val;
			this.getAll()
		},
		handleSizeChange(val) {
			this.form.pageSize = val;
			this.getAll()
		},
		dc() {
			publicExport("/api/shopPay/exportShopPay", this.form, "费用收缴")
		},
		getUsers() { //查询申请人
			this.$http.get("/api/bdShopRenovation/getUserShop").then(res => {
				this.users = res.data.data
			})
		},
		getAll() { //获取表格数据
			this.$http.post("/api/shopPay/queryShopPay", this.form).then(res => {
				this.count = res.data.data.totalNum;
				this.data = res.data.data.items
			})
		}
	},
	created() {
		this.getAll();
		this.getUsers();
	}
}
</script>

<style scoped="scoped">
.box {
	font-size: 16px;
	width: 70%;
}

.box>div {
	margin-bottom: 10px;
}
</style>
